export const getOrDefaults = <T>(
  input: T | undefined | null,
  defaults: T
): T => {
  switch (typeof input) {
    case "undefined":
      return defaults;
    case "string":
      if (input.length > 0) return input;
      else return defaults;
    case "object":
      // null object
      if (input === null) return defaults;
      // empty object
      else if (Object.keys(input).length <= 0) return defaults;
      else return input;
    default:
      return input;
  }
};
